'use client'
import { useState } from 'react'

export default function ReviewStarsList({
  ratingInstructions,
  score,
}: {
  ratingInstructions: string
  score?: number
}) {
  const [rating, setRating] = useState<number>(score || 0)
  const [hoverRating, setHoverRating] = useState<number>(0)

  const handleStarClick = (selectedRating: number) => {
    if (selectedRating === rating) {
      setRating(0)
    } else {
      setRating(selectedRating)
    }
  }

  const handleStarHover = (hoveredRating: number) => {
    setHoverRating(hoveredRating)
  }

  const handleStarLeave = () => {
    setHoverRating(0)
  }

  return (
    <section
      aria-describedby={ratingInstructions}
      className="product-write-review-stars"
      onMouseLeave={handleStarLeave}>
      {[1, 2, 3, 4, 5].map((star, i, arr) => {
        const lastItem = i === arr?.length - 1
        return (
          <button
            id={star.toString()}
            key={star}
            aria-pressed={rating >= star}
            aria-label={`Rating ${star} of 5`}
            type="button"
            className={
              lastItem
                ? 'product-write-review-stars__star--last'
                : 'product-write-review-stars__star'
            }
            onClick={() => handleStarClick(star)}
            onMouseEnter={() => handleStarHover(star)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
              <g clipPath="url(#clip0_3631_4937)">
                <path
                  d="M31.9402 12.3C31.8002 11.86 31.4202 11.55 30.9702 11.48L21.3802 10.09L17.0802 1.39998C16.8802 0.97998 16.4602 0.72998 16.0002 0.72998C15.5402 0.72998 15.1202 0.98998 14.9202 1.39998L10.6302 10.09L1.04022 11.48C0.580218 11.55 0.210218 11.86 0.0702179 12.3C-0.0697821 12.74 0.0402179 13.21 0.370218 12.54L7.31022 20.31L5.67022 30.32 5.77022 30.77 6.15022 31.04C6.52022 31.31 7.01022 31.35 7.42022 31.13L16.0002 26.63L24.5802 31.14C24.7602 31.23 24.9502 31.28 25.1402 31.28C25.3902 31.28 25.6402 31.2 25.8502 31.05C26.2202 30.78 26.4102 30.33 26.3302 29.87L24.6902 20.31L31.6302 12.54C31.9702"
                  strokeWidth="5%"
                  fill={hoverRating >= star || (!hoverRating && rating >= star) ? 'black' : 'white'}
                  stroke="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_3631_4937">
                  <rect width="32" height="32" />
                </clipPath>
              </defs>
            </svg>
          </button>
        )
      })}
      <input type="hidden" id="rating" name="rating" required value={rating} />
    </section>
  )
}
